export const graphDataProvidersEnum = Object.freeze({
  weight: 'weight',
  bp: 'bp',
  pulseox: 'pulseox',
  temp: 'temp',
  gluco: 'gluco',
  spirometer: 'spirometer',
  hr: 'hr',
  sleep: 'sleep',
  airQualityMonitor: 'aqm',
  ptInr: 'ptInr',
});
